
import sortBy from "lodash/sortBy";
import { createLocation, updateLocation, deleteLocation, getLocations } from '../../src/api/metadata.js'
const deliveryLocations = {
  namespaced: true,
  state: {
    locationDeleted: false,
    deliveryLocations: [],
  },
  getters: {
    getDeliveryLocations(state) {
      return state.deliveryLocations;
    },
    getDeliveryLocationDeleted(state) {
      return state.locationDeleted;
    },
  },
  mutations: {
    setDeliveryLocations: (state, payload) => {
      state.deliveryLocations = sortBy(payload, ["address.county", "address.postCode"]);
    },
    setDeliveryLocationDeleted: (state, payload) => {
      state.locationDeleted = payload;
    },
  },
  actions: {
    async getDeliveryLocations({ commit }, buyerAccountId) {
      try {
        const result = await getLocations(buyerAccountId);
        if (result.status === 200) {
          commit("setDeliveryLocations", result.data.locations);
          return result.data.locations;
        } else {
          commit("setDeliveryLocations", []);
          return [];
        }
      } catch (ex) {
        console.dir(ex);
        commit("setDeliveryLocations", []);
      }
    },
    async deleteDeliveryLocation({ commit }, locationId) {
      try {
        const result = await deleteLocation(locationId);
        commit("setDeliveryLocationDeleted", true);
        return result;
      } catch (ex) {
        console.dir(ex);
      }
    },
    async updateDeliveryLocation({ commit }, payload) {
      try {
        delete payload.updated;
        delete payload.deleted;
        const result = await updateLocation(payload._id, payload);
        return result;
      } catch (ex) {
        console.dir(ex);
      }
    },
    async createDeliveryLocation({ commit }, payload) {
      try {
        const result = await createLocation(payload.buyerAccountId, payload.location);
        return result;
      } catch (ex) {
        console.dir(ex);
      }
    }
  },
};

export default deliveryLocations;
